module.exports = __webpack_public_path__ + "img/tourAdBanner.ca8a4a9d.png";